import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const DeletePagesView = lazy(() => import("@/features/delete-pages/view"));

export const Route = createFileRoute("/delete-pages")({
  head: () =>
    pageMeta({
      title: "Delete pages from a PDF",
      description:
        "Click the pages you don't want, then download the cleaned-up file. No re-uploading, no waiting.",
      path: "/delete-pages",
      keywords: "delete pdf pages, remove pdf pages, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <DeletePagesView />
    </Suspense>
  ),
});
